// extracted by mini-css-extract-plugin
module.exports = {"productImage":"_3ONm_","productBadge":"x0FYT","badge":"_3KtvH","defaultImage":"_1_Cig"};